<app-driver-activity [title]="'driverDashboard.widgets.driversInVehicle' | transloco" [count]="count" [icon]="'ph-truck'" [columnHeaders]="columnHeaders"
  [filteredDriversData]="filteredDriversData" [isModal]="isModal" [componentId]="componentId"
  (toggleExpandEvent)="onExpand($event)" [isLoading]="isLoading" [isPageLoading]="isFetching"
  (scrollEvent)="onScroll()" [isLocationColumn]="true" [hasError]="hasError">
</app-driver-activity>